// @ts-nocheck
import axios from "axios";
import { toast } from "sonner";
import { Storage } from "../utilities/setting";
import { ROUTES, CLIENT_SOURCE, CLIENT_SOURCE_HEADER } from "../utilities/constant";

const CONTENT_TYPE = "application/json";
const TIMEOUT = 45000;
const DEFAULT_POST_TIMEOUT = 45000;

let isRedirectingToLogin = false;

const handleUnauthorized = (error) => {
  const status = error?.response?.status;

  if (status === 401 && typeof window !== "undefined") {
    const loginPath = `/${ROUTES.LOGIN}`;
    const alreadyOnLogin = window.location.pathname.includes(loginPath);

    if (!alreadyOnLogin && !isRedirectingToLogin) {
      isRedirectingToLogin = true;
      Storage.clearAll();
      toast.error("Session Expired");
      setTimeout(() => {
        window.location.assign(loginPath);
      }, 1000);
    }
  }

  return Promise.reject(error);
};

const noteApiCallSafe = (config, status) => {
  try {
    const { noteApiCall } = require("./sessionReplay/semanticCapture");
    const started = config?.metadata?.startTime || Date.now();
    noteApiCall(config?.method, config?.url, status, Date.now() - started);
  } catch {
  }
};

export const withAuthRedirect = (instance) => {
  instance.interceptors.request.use((config) => {
    config.metadata = { startTime: Date.now() };
    return config;
  });
  instance.interceptors.response.use(
    (response) => {
      noteApiCallSafe(response.config, response.status);
      return response;
    },
    (error) => {
      noteApiCallSafe(error?.config, error?.response?.status || 0);
      return handleUnauthorized(error);
    }
  );
  return instance;
};

export const apiWithoutHeader = (baseUrl) =>
  axios.create({
    baseURL: baseUrl,
    timeout: TIMEOUT,
    headers: {
      "Content-Type": CONTENT_TYPE,
      [CLIENT_SOURCE_HEADER]: CLIENT_SOURCE
    }
  });

export const apiWithGetHeader = (baseUrl, payload, token) => {

  return withAuthRedirect(axios.create({
    baseURL: baseUrl,
    timeout: TIMEOUT,
    params: payload,
    withCredentials: true,
    headers: {
      "Content-Type": CONTENT_TYPE,
      "Authorization": token,
      [CLIENT_SOURCE_HEADER]: CLIENT_SOURCE
    }
  }));

}


export const apiWithHeader = (baseUrl, CONTENT_TYPE, token, requestTimeout = DEFAULT_POST_TIMEOUT) =>
  withAuthRedirect(axios.create({
    baseURL: baseUrl,
    method: "post",
    timeout: requestTimeout,
    withCredentials: true,
    headers: {
      "Content-Type": CONTENT_TYPE,
      "X-Requested-With": "XMLHttpRequest",
      "Authorization": token,
      [CLIENT_SOURCE_HEADER]: CLIENT_SOURCE
    },
    data: {}
  }));

  export const apiWithoutAuth = (baseUrl,CONTENT_TYPE) => 
    axios.create({
    baseURL: baseUrl,
    method: "post",
    timeout: TIMEOUT,
    headers: {
      "Content-Type": CONTENT_TYPE,
      [CLIENT_SOURCE_HEADER]: CLIENT_SOURCE
    },
    data: {}
  });

  export const fileApiWithHeader = (baseUrl, token) => {
    const headers = {
        "Authorization": token,
        "X-Requested-With": "XMLHttpRequest",
        [CLIENT_SOURCE_HEADER]: CLIENT_SOURCE
    };

    return withAuthRedirect(axios.create({
        baseURL: baseUrl,
        timeout: 10000,
        headers: headers
    }));
};


  

export const apiWithCustomHeader = (headerparams, baseUrl) =>
  withAuthRedirect(axios.create({
    baseURL: baseUrl,
    timeout: TIMEOUT,
    headers: headerparams
  }));
